'use client'

import { Pagination } from 'react-bootstrap'

function PaginationComponent({ scrollTargetRef, pagination, setPagination }) {
  const scrollToTop = () => {
    if (scrollTargetRef.current) {
      const offset = 156 // The value calculated according to the header height.
      const topPosition =
        scrollTargetRef.current.getBoundingClientRect().top + window.pageYOffset - offset
      window.scrollTo({
        top: topPosition,
        behavior: 'smooth'
      })
    }
  }

  return (
    <div className="d-flex justify-content-center">
      <Pagination className="news-pagination d-flex align-self-center">
        <Pagination.Prev
          linkClassName="prev"
          onClick={() => {
            setPagination(prev => ({
              ...prev,
              page: prev.page - 1
            }))
            scrollToTop()
          }}
          disabled={pagination.page === 1}
        />

        {[...Array(pagination.pageCount)].map((_, i) => (
          <Pagination.Item
            key={i + 1}
            active={pagination.page === i + 1}
            onClick={() => {
              setPagination(pageNo => ({
                ...pageNo,
                page: i + 1
              }))
              scrollToTop()
            }}
          >
            {i + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next
          onClick={() => {
            setPagination(prev => ({
              ...prev,
              page: prev.page + 1
            }))
            scrollToTop()
          }}
          disabled={pagination.page === pagination.pageCount}
        />
      </Pagination>
    </div>
  )
}

export default PaginationComponent
